import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  inputsContainer: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    columnGap: 16,
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr'
    }
  }
}))
export default useStyles
